import { render, staticRenderFns } from "./VideoModel.vue?vue&type=template&id=d30c2ef6&scoped=true&"
import script from "./VideoModel.vue?vue&type=script&lang=js&"
export * from "./VideoModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30c2ef6",
  null
  
)

export default component.exports